module.exports = __webpack_public_path__ + "img/heading-02.54df8e68.svg";